import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { __ } from '../../../../helpers/translations';
import AddParticipantModal from '../modals/AddParticipantModal';

function AddParticipantButton({
  survey, template, onChanged, demo,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        title={__('G264')}
        size={demo ? 'sm' : 'md'}
        variant="light"
        disabled={demo}
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faUserPlus} />
      </Button>
      {showModal && (
      <AddParticipantModal
        surveyId={survey.surveyId}
        templateType={template.type}
        disableTeam={false}
        onCancel={() => setShowModal(false)}
        onChanged={async () => {
          setShowModal(false);
          await onChanged();
        }}
      />
      )}
    </>

  );
}

AddParticipantButton.propTypes = {
  survey: PropTypes.shape({
    surveyId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    templateId: PropTypes.string,
    createdBy: PropTypes.string,
    status: PropTypes.string,
    _id: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
  }),
  template: PropTypes.shape({
    type: PropTypes.string,
  }),
  onChanged: PropTypes.func,
  demo: PropTypes.bool,
};

export default AddParticipantButton;
